import React, { useEffect, useMemo, useState } from 'react'

// Estilização
import { Container, Page } from './styles'

// Componente de card para novos projetos
import CardNovosProjetos from '../../../components/CardNovosProjetos'

// icones
import { BsSortAlphaDown, BsSortAlphaUpAlt } from 'react-icons/bs'
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import { Badge } from '@material-ui/core';


// Chamadas da API
import SimpleBackdrop from '../../../components/Backdrop'
import { GET_PROJECTS } from '../../../services/endpoints'
import { mask } from 'remask'
import { AccessTime } from '@material-ui/icons';
import { useAuth } from '../../../contexts/AuthContext';

const projectStatus = {
  paid: 'paid',
  waitingPayment: 'waiting_payment',
  refused: 'refused',
}

function NovosProjetos() {
  const { user } = useAuth();
  const [status, setStatus] = useState(projectStatus.paid)

  const [listProjects, setListProjects] = useState([])

  const [showbackdrop, setShowbackdrop] = useState(false)
  const [abaSelected, setAbaSelected] = useState(1)

  const [filter, setFilter] = useState({
    type: '',
    value: '',
    dig: '',
  })

  const [order, setOrder] = useState('')

  const handleFilter = (dado) => {
    if (!filter.type || !filter.value) return true

    switch (filter.type) {
      case 'name':
        return !!dado.client_name && dado.client_name.toLowerCase().includes(filter.value.toLowerCase())
      case 'cpf':
        return !!dado.client_cpf && dado.client_cpf.replace(/[^0-9]/g, '').includes(filter.value.replace(/[^0-9]/g, ''))
      case 'cnpj':
        return !!dado.client_cnpj && dado.client_cnpj.replace(/[^0-9]/g, '').includes(filter.value.replace(/[^0-9]/g, ''))
      default:
        return true
    }
  }

  const handleFilterValue = (event) => {
    if (filter.type === 'cpf') {
      setFilter({ ...filter, value: mask(event.target.value, '999.999.999-99') })
    } else if (filter.type === 'cnpj') {
      setFilter({ ...filter, value: mask(event.target.value, '99.999.999/9999-99') })
    } else {
      setFilter({ ...filter, value: event.target.value })
    }
  }

  // === callbacks vindos do Dialogoverprojeto ===
  const handleProjectPixUpdated = (projectId, newCode) => {
    setListProjects(prev =>
      prev.map(p => (p.id === projectId ? { ...p, pix_code: newCode } : p))
    )
  }

  const handleProjectPaymentUpdated = (projectId, receiptId, isPaid) => {
    setListProjects(prev => {
      const updated = prev.map(p =>
        p.id === projectId
          ? {
            ...p,
            receipts: (p.receipts || []).map(r =>
              r.id === receiptId ? { ...r, is_paid: isPaid } : r
            ),
          }
          : p
      )

      // Se estou na aba de pagos e o pagamento foi cancelado,
      // removo o projeto imediatamente da lista renderizada.
      if (status === projectStatus.paid && !isPaid) {
        return updated.filter(p => p.id !== projectId)
      }

      // (opcional) Se estou na aba "aguardando pagamento" e o pagamento foi confirmado,
      // também posso removê-lo daqui para ele aparecer na aba de pagos quando trocar a aba.
      if (status === projectStatus.waitingPayment && isPaid) {
        return updated.filter(p => p.id !== projectId)
      }

      return updated
    })
  }

  // Deriva a lista filtrada/ordenada dos projetos atuais SEM criar outro state.
  const filteredProjects = useMemo(() => {
    const base = Array.isArray(listProjects) ? listProjects : []

    const ordered = [...base].sort((a, b) => {
      if (order === 'AZ') {
        return (a.client_name || '').localeCompare(b.client_name || '')
      } else if (order === 'ZA') {
        return (b.client_name || '').localeCompare(a.client_name || '')
      } else if (order === 'primeiros') {
        return new Date(b.created_at) - new Date(a.created_at)
      } else if (order === 'ultimos') {
        return new Date(a.created_at) - new Date(b.created_at)
      }
      return 0
    })

    return ordered.filter(handleFilter)
  }, [listProjects, filter, order])

  useEffect(() => {
    GET_PROJECTS(setListProjects, setShowbackdrop, {
      status,
      hasDeadline: status === projectStatus.waitingPayment ? false : undefined,
      hasStages: status === projectStatus.waitingPayment ? false : undefined,
      hasResponsibles: status === projectStatus.waitingPayment ? false : undefined,
    })
  }, [status])

  return (
    <Container>
      <Page>
        <header>
          <h1>Projetos</h1>
          <span>
            Confira os novos projetos, analise, visualize, aceite e delegue um responsável.
          </span>
        </header>
        <content>
          {user?.role === 'GERENTE' && (
          <>
              <div className="div__options__project">
                <Badge
                  overlap="circular"
                  badgeContent={
                    status === projectStatus.paid &&
                    Object.keys(listProjects).length !== 0
                      ? listProjects?.total
                      : undefined
                  }
                  style={{ marginTop: '-0.4rem' }}
                  color="secondary"
                >
                  <button
                    className={
                      abaSelected === 1
                        ? 'button_project btn__aba_selected'
                        : 'button_project'
                    }
                    onClick={() => {
                      setStatus(projectStatus.paid)
                      setAbaSelected(1)
                    }}
                  >
                    <AssignmentOutlinedIcon /> Projetos Pagos
                  </button>
                </Badge>
                <Badge
                  overlap="circular"
                  badgeContent={
                    status === projectStatus.waitingPayment &&
                    Object.keys(listProjects).length !== 0
                      ? listProjects?.total
                      : undefined
                  }
                  style={{ marginTop: '-0.4rem' }}
                  color="secondary"
                >
                  <button
                    className={
                      abaSelected === 2
                        ? 'button_project btn__aba_selected'
                        : 'button_project'
                    }
                    onClick={() => {
                      setStatus(projectStatus.waitingPayment)
                      setAbaSelected(2)
                    }}
                  >
                    <AccessTime /> Aguardando Pagamento
                  </button>
                </Badge>
                <Badge
                  overlap="circular"
                  badgeContent={
                    status === projectStatus.refused &&
                    Object.keys(listProjects).length !== 0
                      ? listProjects.total
                      : undefined
                  }
                  style={{ marginTop: '-0.4rem' }}
                  color="secondary"
                >
                  <button
                    className={
                      abaSelected === 3
                        ? 'button_project btn__aba_selected'
                        : 'button_project'
                    }
                    onClick={() => {
                      setStatus(projectStatus.refused)
                      setAbaSelected(3)
                    }}
                  >
                    <HighlightOffIcon /> Projetos Recusados
                  </button>
                </Badge>
              </div>
              <p className="p__subtitle_aba_selected">
                {abaSelected === 1
                  ? `Lista de todos os projetos pagos aguardando aprovação.`
                  : abaSelected === 2
                  ? 'Lista de todos os projetos lançados na plataforma aguardando pagamento.'
                  : 'Lista de projetos recusados (pagos e não pagos).'}
              </p>
            </>
          )}
          <div className="div__fieldFilter">
            <div className="div__filters">
              <select
                onChange={(event) =>
                  setFilter({
                    ...filter,
                    type: event.target.value,
                    value: '',
                    dig: '',
                  })
                }
                value={filter.type}
                style={{ maxWidth: 200 }}
              >
                <option value="" selected>
                  Filtro
                </option>
                <option value="name">Cliente</option>
                <option value="cpf">CPF</option>
                <option value="cnpj">CNPJ</option>
                {/* <option value="state">Estado</option> */}
                {/* <option value="concessionaria">Concessionária</option> */}
                {/* <option value="open_projects">Projetos em aberto</option> */}
                {/* <option value="delayed_projects">Projetos atrasados</option> */}
                {/* <option value="completed_projects">Projetos finalizados</option>
                <option value="suspended_projects">Projetos suspensos</option> */}
              </select>

              <input
                placeholder={
                  filter.type === 'name'
                    ? 'Digite o nome'
                    : filter.type === 'email'
                      ? 'Digite o E-mail'
                      : filter.type === 'cpf'
                        ? 'Digite o CPF'
                        : filter.type === 'cnpj'
                          ? 'Digite o CNPJ'
                          : ' - '
                }
                value={filter.value}
                disabled={!filter.type}
                onChange={handleFilterValue}
                style={{
                  display:
                    filter.type === 'name' ||
                      filter.type === 'email' ||
                      filter.type === 'cpf' ||
                      filter.type === 'cnpj'
                      ? 'block'
                      : 'none',
                }}
              />

              <select
                required
                name="state"
                style={{
                  flex: 1,
                  display: filter.type === 'state' ? 'block' : 'none',
                }}
                value={filter.value}
                onChange={handleFilterValue}
              >
                <option value="" disabled selected>
                  Escolha o estado
                </option>
                <option value="AC">AC</option>
                <option value="AL">AL</option>
                <option value="AP">AP</option>
                <option value="AM">AM</option>
                <option value="BA">BA</option>
                <option value="CE">CE</option>
                <option value="DF">DF</option>
                <option value="ES">ES</option>
                <option value="GO">GO</option>
                <option value="MA">MA</option>
                <option value="MT">MT</option>
                <option value="MS">MS</option>
                <option value="MG">MG</option>
                <option value="PA">PA</option>
                <option value="PB">PB</option>
                <option value="PR">PR</option>
                <option value="PE">PE</option>
                <option value="PI">PI</option>
                <option value="RJ">RJ</option>
                <option value="RN">RN</option>
                <option value="RS">RS</option>
                <option value="RO">RO</option>
                <option value="RR">RR</option>
                <option value="RC">SC</option>
                <option value="SP">SP</option>
                <option value="SE">SE</option>
                <option value="TO">TO</option>
              </select>
            </div>
            <div className="div__order">
              <button
                className={order === 'AZ' ? 'btn__esq btn__ativ' : 'btn__esq'}
                onClick={() => {
                  order === 'AZ' ? setOrder('') : setOrder('AZ')
                }}
              >
                <BsSortAlphaDown style={{ fontSize: '1.4rem' }} />
              </button>
              <button
                className={order === 'ZA' ? 'btn_meio btn__ativ' : 'btn_meio'}
                onClick={() => {
                  order === 'ZA' ? setOrder('') : setOrder('ZA')
                }}
              >
                <BsSortAlphaUpAlt style={{ fontSize: '1.4rem' }} />
              </button>

              <button
                className={
                  order === 'primeiros' ? 'btn_meio btn__ativ' : 'btn_meio'
                }
                onClick={() => {
                  order === 'primeiros' ? setOrder('') : setOrder('primeiros')
                }}
              >
                Recentes
              </button>
              <button
                className={
                  order === 'ultimos' ? 'btn__dir btn__ativ' : 'btn__dir'
                }
                onClick={() => {
                  order === 'ultimos' ? setOrder('') : setOrder('ultimos')
                }}
              >
                Antigos
              </button>
            </div>
          </div>

          <div className="div__deck">
            {filteredProjects?.length > 0 &&
              filteredProjects.map((proj, idx) => (
                <CardNovosProjetos
                  key={idx}
                  proj={proj}
                  idx={idx}
                  abaSelected={abaSelected}
                  atualizar={async () => {
                    // mantém a mesma aba/status atual
                    GET_PROJECTS(
                      setListProjects,
                      setShowbackdrop,
                      {
                        status,
                        hasDeadline: status === projectStatus.waitingPayment ? false : undefined,
                        hasStages: status === projectStatus.waitingPayment ? false : undefined,
                        hasResponsibles: status === projectStatus.waitingPayment ? false : undefined,
                      },
                    )
                  }}
                  onProjectPixUpdated={handleProjectPixUpdated}
                  onProjectPaymentUpdated={handleProjectPaymentUpdated}
                />
              ))}
          </div>
        </content>
        {/* 
        {!!listProjects?.data ? (
          <div
            className="div__viewMore"
            onClick={() => setListidx(listidx + 6)}
          >
            <Pagination
              page={pages}
              total={listProjects?.total}
              rowsPerPage={rows}
              handleChangeRowsPerPage={handleChangeRow}
              handleChangePage={handleChangePage}
            />
          </div>
        ) : listProjects?.total === 0 ? (
          <div style={{ margin: '2rem 1rem' }}>Nenhum projeto encontrado</div>
        ) : listProjects?.total === 0 && !filter.type ? (
          <div style={{ margin: '2rem 1rem' }}>Nenhum projeto cadastrado</div>
        ) : (
          <div style={{ margin: '2rem 1rem' }}>
            {status === projectStatus.refused
              ? 'Sem mais projetos recusados'
              : 'Sem mais novos projetos'}
          </div>
        )} */}

        {filteredProjects.length === 0 && (
          <div style={{ margin: '2rem 1rem', textAlign: 'center' }}>
            Nenhum integrador encontrado.
          </div>
        )}
      </Page>
      {showbackdrop && <SimpleBackdrop />}
    </Container>
  )
}

export default NovosProjetos
